// lazysizes
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/bgset/ls.bgset';

import 'lazysizes';

window.lazySizesConfig = window.lazySizesConfig || {}
window.lazySizesConfig.addClasses = !0

window.lazySizesConfig.customMedia = {
  '--maxXXS': '(max-width: 20.000rem)',
  '--maxXS': '(max-width: 35.9375rem)',
  '--maxSM': '(max-width: 47.9375rem)',
  '--maxMD': '(max-width: 61.9375rem)',
  '--maxLG': '(max-width: 74.9375rem)',
  '--maxXL': '(max-width: 87.9375rem)',
};
